import React, { useEffect } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { appLoadDataAsyncThunk, claimDevelopmentTeamRewardsAsyncThunk } from '../../redux/pagesSlices/emolume_bank';
import CustomButton from '../customs/CustomButton';

export default function Index({ networkID, provider, address }) {
    const dispatch=useDispatch()
    return (
        <div className='method-component'>
            <h2>Claim development team Reward</h2>
            <p>You can claim the development team reward 10% funds will transfer to all members equally.</p>
            <Form noValidate>
                <div className='contact-form'>
                    <div className='contact-us '>
                        <div className='inner-row'>
                            <CustomButton
                                title={'Claim Funds'}
                                type="submit"
                                slice={'bank'}
                                action={"claimDevelopmentTeamRewardsAsyncThunk"}
                                variant="warning"
                                btnClass="buy-btn w-100"
                                onClick={(e) => {
                                    e.preventDefault();
                                    dispatch(claimDevelopmentTeamRewardsAsyncThunk({ networkID, provider,address }))
                                }
                                }
                            />
                        </div>

                    </div>
                </div>
            </Form>
        </div>
    )
}
